<template>
    <div class="sign-in-form">
        <h1>Sign In</h1>
        <form @submit.prevent="handleSubmit">
            <div>
                <label for="email">Email:</label>
                <input type="email" v-model="email" required />
            </div>
            <div>
                <label for="password">Password:</label>
                <input type="password" v-model="password" required />
            </div>
            <button type="submit">Sign In</button>
        </form>
    </div>
</template>

<script>
export default {
    name: 'SignUpForm',
    data() {
        return {
            email: '',
            password: ''
        };
    },
    methods: {
        handleSubmit() {
            // Handle sign in logic here
            console.log('Email:', this.email);
            console.log('Password:', this.password);
        }
    }
};
</script>

<style scoped>
.sign-in-form {
    max-width: 400px;
    margin: 0 auto;
    padding: 1em;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.sign-in-form h1 {
    text-align: center;
}

.sign-in-form div {
    margin-bottom: 1em;
}

.sign-in-form label {
    display: block;
    margin-bottom: 0.5em;
}

.sign-in-form input {
    width: 100%;
    padding: 0.5em;
    box-sizing: border-box;
}

.sign-in-form button {
    width: 100%;
    padding: 0.5em;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.sign-in-form button:hover {
    background-color: #0056b3;
}
</style>